import * as ConsentApi from './api';
import * as Api from 'features/document/edit/partners/api';
import { sendHttpCommandAndWaitForEvent, sendHttpRequest } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';
import * as types from './actionTypes';
import * as eventTypes from './eventTypes';
import { getConsentsIsLoaded } from './selectors';

export function loadPartnerConsent(documentId, siteId, partnerId, isAssociatedPartner) {
  return async (dispatch, getState) => {
    const isLoaded = getConsentsIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }

    try {
      const partnerConsents = await dispatch(sendHttpRequest(Api.getPartnerConsent(documentId, siteId, partnerId, isAssociatedPartner)));
      dispatch({ type: types.LOAD_PARTNER_CONSENTS_SUCCEEDED, payload: { partnerConsents } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateOfferPartnerConsents(consents, isAssociatedPartner) {
  return async dispatch => {
    try {
      if (isAssociatedPartner) {
        await dispatch(
          sendHttpCommandAndWaitForEvent(
            ConsentApi.updateOfferAssociatedPartnerConsents(consents),
            'RunningOfferCommand',
            [eventTypes.OFFER_PARTNER_CONSENTS_UPDATED],
            false
          )
        );
      } else {
        await dispatch(
          sendHttpCommandAndWaitForEvent(
            Api.updateOfferClientConsents(consents),
            'RunningOfferCommand',
            [eventTypes.OFFER_PARTNER_CONSENTS_UPDATED],
            false
          )
        );
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function printOfferClientConsents(data) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.printOfferClientConsents(data),
          'RunningOfferCommand',
          [eventTypes.OFFER_PARTNER_CONSENT_DOWNLOADED],
          false
        )
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function uploadOfferConsentDocument(documentId, siteId, formData, progressCallback) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.uploadOfferConsentDocument(documentId, siteId, formData, progressCallback),
          'UploadDocument',
          [eventTypes.OFFER_CONSENT_DOCUMENT_UPLOADED],
          false
        )
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
